/* @fflow */
import React from 'react';
import Table from '../../UIKit/Table';
import UploadFilesColumns from './UploadFilesColumns';
import UploadFilesRows from './UploadFilesRows';

export default ({ children, handleDelete }) =>
  <Table>
    <UploadFilesColumns />
    <UploadFilesRows handleOnClick={ handleDelete }>
      { children }
    </UploadFilesRows>
  </Table>;
